import { Skeleton } from '@atom/mui';

import classes from './skeletonRow.module.css';

const SkeletonTableRow = () => (
  <div className={classes.skeletonTableRow}>
    <div className={classes.skeletonTableCell1}>
      <Skeleton />
    </div>
    <div className={classes.skeletonTableCell2}>
      <Skeleton />
    </div>
    <div className={classes.skeletonTableCell3}>
      <Skeleton />
    </div>
    <div className={classes.skeletonTableCell4}>
      <Skeleton />
    </div>
  </div>
);

export default SkeletonTableRow;
